import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Injectable()
export class MetaService {
  defDescription = 'RentMy – The complete rental management solution';
  defKeywords = 'RentMy, rental, equipment rental, booking, party rental';
  defTitle = 'RentMy';
  constructor(private meta: Meta, private title: Title,@Inject(DOCUMENT) private document: any) {}

  updateTags(data) {
    // console.log(data);
    for (let d of data) {
      this.meta.updateTag(d);
    }
  }

  setTitle(name) {
    this.title.setTitle(name);
  }
  addTags(data) {
    const metaItems = new Object();
    for (let d in data) {
      const name = d.split("home_page_")[1];
      if (name === "title") {
        metaItems[name] = data[d];
        this.title.setTitle(data[d]);
        this.meta.updateTag({ name: 'title', content: data[d] });
      } else {
        metaItems[name] = data[d];
        this.meta.updateTag({ name: String(name), content: data[d] });
      }
    }
    // let metaEl: HTMLMetaElement = this.meta.getTag('name = "description"');
    // console.log(metaEl);
   // console.log(metaItems);
    this.addSeoDescription(metaItems);
  }

  addTagsForAdmin(data) {
    const metaItems = new Object();
    for (let d in data) {
      const name = d.split("home_page_")[1];
      
        metaItems[name] = data[d];
        this.meta.updateTag({ name: String(name), content: data[d] });
      
    }
   
    this.addSeoDescription(metaItems);
  }

  addSeoDescription(metaItems) {
    let url = this.document.location.href;
    url = !url.includes('https') ? url.replace('http','https') : url;
    const data = [
      { name: "description", content: metaItems.description || "" },
      { name: "keyword", content: metaItems.keywords || "" },
      { name: "twitter:description", content: metaItems.description || "" },
      { name: "twitter:title", content: metaItems.title || ""},
      { name: "viewport", content: "width=device-width, initial-scale=1, shrink-to-fit=no" },
      { name: "author", content: metaItems.title || "" },
      { name: "keywords", content: metaItems.keywords || "" }, //not set in index.html so, can't be updated
      { property: "og:title", content: metaItems.title || ""},
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: metaItems.site_name || ""},
      { property: "og:description", content: metaItems.description || ""},
      { property: "og:url", content: url }
    ];
    this.updateTags(data);
  }
}
